import { render } from "./manage-direct-debit-planned-changes.vue?vue&type=template&id=1808efc6"
import script from "./manage-direct-debit-planned-changes.vue?vue&type=script&lang=js"
export * from "./manage-direct-debit-planned-changes.vue?vue&type=script&lang=js"
script.render = render

export default script